import { Moon, Sun } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * The sun/moon quick toggle beside the role switch — the phone home's header
 * control. One press flips to the other palette and saves it; the full
 * فاتح · داكن · تلقائي choice lives in the account menu.
 *
 * The icon shows where the press takes you: a moon on paper, a sun at night.
 */
export function ThemeToggle() {
  const { t } = useLanguage();
  const { scheme, setPreference } = useTheme();
  const dark = scheme === 'dark';
  const label = t(dark ? 'learn.home.themeLight' : 'learn.home.themeDark');
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={label}
      title={label}
      onClick={() => setPreference(dark ? 'light' : 'dark')}
      className="flex h-9 w-9 items-center justify-center rounded-full text-ink transition-colors hover:bg-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      {dark
        ? <Sun className="h-[18px] w-[18px]" strokeWidth={1.8} aria-hidden="true" />
        : <Moon className="h-[18px] w-[18px]" strokeWidth={1.8} aria-hidden="true" />}
    </button>
  );
}
